import cn from 'classnames'
import { isValidArray, isValidString, tr } from 'mmfintech-commons'
import { isValidElement, type ReactNode, useId } from 'react'
import ReactTooltip from 'react-tooltip'
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard'
import { CoreCopyButton } from '../CoreCopyButton'

import './corePreviewLine.scss'

type iconType =
  | 'account'
  | 'date'
  | 'fee'
  | 'method'
  | 'recipient'
  | 'reference'
  | 'transaction-id'
  | 'category-transaction'
  | 'percentage'
  | 'description'

interface ICorePreviewLineProps {
  iconType?: iconType
  title: string
  text: string | string[] | ReactNode
  className?: string
  value?: string
  isCopyVisible?: boolean
}

const CorePreviewLine = ({ iconType, text, title, className, value, isCopyVisible }: ICorePreviewLineProps) => {
  const tooltipId = useId()
  const { copied, copy } = useCopyToClipboard()

  if (iconType === 'method' && isValidString(text)) {
    text = text.toLowerCase().replace(/_/g, ' ')
  }

  return text ? (
    <div className={cn('preview-line-wrapper', className)}>
      <div>
        <span className='preview-line-label' data-test={`preview-line-title-${title}`}>
          {title}
        </span>
        <div
          data-test={`preview-line-text-${title}`}
          data-for={isValidString(text) ? tooltipId : undefined}
          className={cn('preview-line-content-moving', {
            'preview-line-content': iconType === 'method'
          })}
          onMouseOver={event => {
            const target = event.target as HTMLDivElement
            event.stopPropagation()
            if (target.clientWidth > target.closest('.preview-line-wrapper').clientWidth) {
              target.style.transform = `translateX(${-(target.clientWidth - target.closest('.preview-line-wrapper').clientWidth)}px)`
              target.style.cursor = 'pointer'
            }
          }}
          onMouseLeave={event => {
            const target = event.target as HTMLDivElement
            target.style.transform = `translateX(0px)`
          }}
          onClick={() => isValidString(text) && copy(text)}
        >
          {isValidElement(text) && text}
          {isValidString(text) ? (
            <p>{text}</p>
          ) : isValidArray(text) ? (
            text.map((line: string, index: number) => {
              if (index === 0 && line && line.length > 10) {
                return (
                  <div key={index} className='preview-line-card-number'>
                    <p>{'*'.repeat(line.length - 4) + line.slice(-4)}</p>
                  </div>
                )
              }
              return (
                <p key={index} className='preview-line-card-details'>
                  {line}
                </p>
              )
            })
          ) : (
            ''
          )}
          {isCopyVisible && value && <CoreCopyButton value={value} />}
        </div>
      </div>
      {isValidString(text) && (
        <ReactTooltip
          id={tooltipId}
          content={tr('FRONTEND.GENERIC.COPIED', 'Copied')}
          isOpen={copied}
          imperativeModeOnly
          place='top'
          type='dark'
          class='copy-text-tooltip'
          padding='8px 10px'
        />
      )}
    </div>
  ) : null
}

export default CorePreviewLine
